export const ReviewAnswerStatus = {
    ARCHIVED: 'Archived',
    COMPLETED: 'Completed',
    IN_PROGRESS: 'InProgress',
} as const;

export type ReviewAnswerStatusValues = (typeof ReviewAnswerStatus)[keyof typeof ReviewAnswerStatus];
